import { Link } from "react-router-dom";

const SectionTitle = ({
    title,
    buttonText,
    buttonUrl,
    backUrl,
}: {
    title: string;
    buttonText?: string;
    buttonUrl?: string;
    backUrl?: string;
}) => {
    return (
        <div className="section-title mb-5">
            {backUrl && (
                <Link className="btn btn-outline-primary mb-4" to={backUrl}>
                    Back
                </Link>
            )}
            <div
                className={`d-md-flex align-items-center justify-content-between ${
                    backUrl ? "mt-4" : ""
                }`}
            >
                <h3 className="mb-md-0">{title}</h3>
                {buttonUrl && (
                    <Link to={buttonUrl} className="btn btn-primary btn-lg" title={buttonText}>
                        {buttonText ?? "Create"}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default SectionTitle;
